// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__c6Q51","title":"BackImages_title__10gpE","images":"BackImages_images__kJlau"};